import React from 'react';

interface SectionLabelProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  reveal?: boolean;
}

/** "—— Calor" style eyebrow used at the top of each section. */
export default function SectionLabel({
  children,
  className = '',
  style,
  reveal = true,
}: SectionLabelProps) {
  return (
    <p
      className={`label-mono flex items-center gap-3 ${className}`}
      style={style}
      {...(reveal ? { 'data-reveal': '' } : {})}
    >
      <span aria-hidden="true" className="inline-block w-8 h-px bg-[var(--copper)]" />
      <span className="opacity-70">{children}</span>
    </p>
  );
}
